var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { map } from 'lodash';
import { EntityValue, Icon, useLang } from '@shapeable/ui';
import { ScaleLoader } from 'react-spinners';
import { classNames, chatValueIsEntity, chatValueIsText } from '@shapeable/utils';
import { ChevronDownIconGlyph, ChevronUpIconGlyph, CrossIcon, QuestionIcon, useIcons } from '@shapeable/icons';
var cls = classNames('gpt-output-header');
export var GptOutputHeaderDefaultProps = {
  iconProps: {
    size: 24,
    color: 'text'
  },
  variant: 'topic intersection',
  isPartial: false
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    font-size: 1em;\n    padding: 16px 20px 20px 20px;\n    align-items: center;\n    justify-content: flex-start;\n    color: ", ";\n    gap: ", ";\n    width: 100%;\n    box-sizing: border-box;\n    border-bottom: 1px solid var(--shapeable-line-semi-subtle, #DADADA);\n    user-select: none;\n    \n    \n    ", "\n  "], ["\n    display: flex;\n    font-size: 1em;\n    padding: 16px 20px 20px 20px;\n    align-items: center;\n    justify-content: flex-start;\n    color: ", ";\n    gap: ", ";\n    width: 100%;\n    box-sizing: border-box;\n    border-bottom: 1px solid var(--shapeable-line-semi-subtle, #DADADA);\n    user-select: none;\n    \n    \n    ", "\n  "])), theme.COLOR('dark'), theme.UNIT(5), function (_a) {
    var isPartial = _a.isPartial;
    return !isPartial && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      cursor: pointer;\n      &:hover ", " {\n        ", ";\n      }\n    "], ["\n      cursor: pointer;\n      &:hover ", " {\n        ", ";\n      }\n    "])), cls.dot('disclosure-icon'), theme.FILL('primary'));
  }),
  tablet: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      border-bottom: none;\n  "], ["\n      border-bottom: none;\n  "])))
});
var LayoutStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    width: 100%;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    width: 100%;\n  "]))),
  tablet: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    flex-direction: row;\n    align-items: center;\n  "], ["\n    flex-direction: row;\n    align-items: center;\n  "])))
});
var BodyStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    display: flex;\n    width: 100%;\n    padding: ", " 0px;\n    gap: ", ";\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n  "], ["\n    display: flex;\n    width: 100%;\n    padding: ", " 0px;\n    gap: ", ";\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n  "])), theme.UNIT(2), theme.UNIT(5)),
  tablet: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    justify-content: space-between;\n  "], ["\n    justify-content: space-between;\n  "])))
});
var IconTemplateStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding-right: ", ";\n    \n  "], ["\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding-right: ", ";\n    \n  "])), theme.UNIT(3))
});
var PromptIconStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n\n  "], ["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n\n  "])))
});
var TemplateLabelStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    font-weight: 500;\n    color: inherit;\n    font-size: ", "em;\n  "], ["\n    font-weight: 500;\n    color: inherit;\n    font-size: ", "em;\n  "])), 15 / 16)
});
var UiStyles = breakpoints({
  base: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    display: none;\n  "], ["\n    display: none;\n  "]))),
  tablet: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    display: flex;\n    justify-content: flex-start;\n    flex: 1 0 0;\n    padding-right: ", ";\n  "], ["\n    display: flex;\n    justify-content: flex-start;\n    flex: 1 0 0;\n    padding-right: ", ";\n  "])), theme.UNIT(5))
});
var MobileUiStyles = breakpoints({
  base: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    display: flex;\n    justify-content: flex-start;\n    padding-top: ", ";\n    flex: 1 0 0;\n    \n  "], ["\n    display: flex;\n    justify-content: flex-start;\n    padding-top: ", ";\n    flex: 1 0 0;\n    \n  "])), theme.UNIT(5)),
  tablet: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    display: none;\n  "], ["\n    display: none;\n  "])))
});
var TextAreaStyles = breakpoints({
  base: css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    font-weight: 500;\n    display: flex;\n    align-items: center;\n    justify-self: stretch;\n\n    margin-left: ", ";\n    display: flex;\n\n    &:first-child {\n      margin-left: 0;\n    }\n  "], ["\n    font-weight: 500;\n    display: flex;\n    align-items: center;\n    justify-self: stretch;\n\n    margin-left: ", ";\n    display: flex;\n\n    &:first-child {\n      margin-left: 0;\n    }\n  "])), theme.UNIT(5)),
  tablet: css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    padding-left: ", ";\n    ", ";\n  "], ["\n    padding-left: ", ";\n    ", ";\n  "])), theme.UNIT(5), theme.DOT_BG('v', 'line-semi-subtle', 2, 6))
});
var IconStyles = breakpoints({
  base: css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    flex-shrink: 0;\n  "], ["\n    flex-shrink: 0;\n  "])))
});
var FetchIconsStyles = breakpoints({
  base: css(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    gap: ", ";\n    flex-shrink: 0;\n  "], ["\n    display: flex;\n    align-items: center;\n    gap: ", ";\n    flex-shrink: 0;\n  "])), theme.UNIT(8))
});
var StopIconStyles = breakpoints({
  base: css(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    margin-top: -2px;\n  "], ["\n    margin-top: -2px;\n  "])))
});
var ValueStyles = breakpoints({
  base: css(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n    margin-left: ", ";\n    height: 30px;\n    display: flex;\n\n    &:first-child {\n      margin-left: 0;\n    }\n\n    &:last-child {\n  \n    }\n  "], ["\n    margin-left: ", ";\n    height: 30px;\n    display: flex;\n\n    &:first-child {\n      margin-left: 0;\n    }\n\n    &:last-child {\n  \n    }\n  "])), theme.UNIT(5)),
  tablet: css(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n    padding-left: ", ";\n    ", ";\n  \n  "], ["\n    padding-left: ", ";\n    ", ";\n  \n  "])), theme.UNIT(5), theme.DOT_BG('v', 'line-semi-subtle', 2, 6))
});
var StopStyles = breakpoints({
  base: css(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n    cursor: pointer;\n    &:hover {\n      ", ";\n    }\n  "], ["\n    cursor: pointer;\n    &:hover {\n      ", ";\n    }\n  "])), theme.FILL('primary'))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Layout: styled.div.attrs(cls.attr('layout'))(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), LayoutStyles),
  Body: styled.div.attrs(cls.attr('body'))(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  IconTemplate: styled.div.attrs(cls.attr('icon-template'))(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), IconTemplateStyles),
  PromptIcon: styled.div.attrs(cls.attr('prompt-template'))(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), PromptIconStyles),
  TemplateLabel: styled.span.attrs(cls.attr('template-label'))(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), TemplateLabelStyles),
  Ui: styled.div.attrs(cls.attr('ui'))(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), UiStyles),
  TextArea: styled.span.attrs(cls.attr('text-area'))(templateObject_30 || (templateObject_30 = __makeTemplateObject(["", ""], ["", ""])), TextAreaStyles),
  Value: styled(EntityValue)(templateObject_31 || (templateObject_31 = __makeTemplateObject(["", ""], ["", ""])), ValueStyles),
  MobileUi: styled.div.attrs(cls.attr('mobile-ui'))(templateObject_32 || (templateObject_32 = __makeTemplateObject(["", ""], ["", ""])), MobileUiStyles),
  FetchIcons: styled.div.attrs(cls.attr('fetch-icons'))(templateObject_33 || (templateObject_33 = __makeTemplateObject(["", ""], ["", ""])), FetchIconsStyles),
  StopIcon: styled(Icon)(templateObject_34 || (templateObject_34 = __makeTemplateObject(["", ""], ["", ""])), StopIconStyles),
  Stop: styled(CrossIcon)(templateObject_35 || (templateObject_35 = __makeTemplateObject(["", ""], ["", ""])), StopStyles),
  Icon: styled(Icon)(templateObject_36 || (templateObject_36 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  DisclosureIcon: styled(Icon).attrs(cls.attr('disclosure-icon'))(templateObject_37 || (templateObject_37 = __makeTemplateObject(["", ""], ["", ""])), IconStyles)
};
export var GptOutputHeader = function (props) {
  var _a;
  var className = props.className,
    iconComponent = props.iconComponent,
    iconProps = props.iconProps,
    variant = props.variant,
    onClick = props.onClick,
    onStopClick = props.onStopClick,
    isExpanded = props.isExpanded,
    prompt = props.prompt;
  var icons = useIcons();
  var t = useLang();
  if (!prompt) {
    return null;
  }
  var isPartial = props.isPartial;
  var template = prompt.template;
  var Icon = icons[(_a = template === null || template === void 0 ? void 0 : template.icon) === null || _a === void 0 ? void 0 : _a.component] || QuestionIcon;
  var handleStopClick = React.useCallback(function (e) {
    e.stopPropagation();
    onStopClick();
  }, [onStopClick]);
  return React.createElement(My.Container, {
    isPartial: isPartial,
    onClick: onClick,
    className: cls.name(className)
  }, React.createElement(My.Layout, null, React.createElement(My.Body, null, React.createElement(My.IconTemplate, null, React.createElement(My.PromptIcon, null, React.createElement(My.Icon, {
    size: 36,
    color: 'dark'
  }, React.createElement(Icon, null))), React.createElement(My.TemplateLabel, null, (template === null || template === void 0 ? void 0 : template.label) || 'Question')), React.createElement(My.Ui, null, map(prompt.variables, function (value, i) {
    if (chatValueIsText(value)) {
      return React.createElement(My.TextArea, {
        key: i
      }, value);
    }
    if (chatValueIsEntity(value)) {
      return React.createElement(My.Value, {
        key: i,
        entity: value,
        variant: 'small'
      });
    }
  })), isPartial && React.createElement(My.FetchIcons, null, React.createElement(ScaleLoader, {
    color: '#5CACC3',
    width: 3,
    height: 20
  }), React.createElement(My.StopIcon, {
    onClick: handleStopClick,
    title: t('Cancel Request'),
    color: 'text',
    size: 24
  }, React.createElement(My.Stop, null))), !isPartial && React.createElement(My.DisclosureIcon, {
    size: 18,
    color: 'text'
  }, isExpanded ? React.createElement(ChevronUpIconGlyph, null) : React.createElement(ChevronDownIconGlyph, null))), React.createElement(My.MobileUi, null, map(prompt.variables, function (value, i) {
    if (chatValueIsText(value)) {
      return React.createElement(My.TextArea, {
        key: "mobile-".concat(i)
      }, value);
    }
    if (chatValueIsEntity(value)) {
      return React.createElement(My.Value, {
        key: "mobile-".concat(i),
        entity: value,
        variant: 'small'
      });
    }
  }))));
};
GptOutputHeader.cls = cls;
GptOutputHeader.defaultProps = GptOutputHeaderDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37;